// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Y_dvs","content":"Consent_content__130hs","footer":"Consent_footer__2l828"};